import type { FollowInvite } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  CaretRightIcon,
  IconButton,
} from "@tandemdiabetes/sugarmate-react-components"
import { Link } from "@tanstack/react-router"
import styles from "./Sharing.module.scss"

interface FollowInviteProps {
  followInvite: FollowInvite;
}

/*
 * display info about a invite
 */
export function FollowerInvite(props: FollowInviteProps) {
  const { followInvite } = props

  return (
    <li>
      <Link
        to={"/data_sharing/sharing/$followInviteId/manage_invitation"}
        params={{ followInviteId: followInvite.id }}
        id={`followInvite-${followInvite.id}`}
        className={styles.listItemContainer}
      >
        <span
          className={styles.listItemEmail}
          id="invited-follower-email"
        >
          {followInvite.email}
        </span>
        <IconButton
          className={styles.listItemSettingsButton}
          stylePreset="withoutBackground"
        >
          <CaretRightIcon />
        </IconButton>
      </Link>
    </li>
  )
}
